/* eslint-disable @typescript-eslint/explicit-function-return-type */
import { ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { ERoleAdminString } from 'src/app/shared/data/role.enum';
import { PartnerService } from '../../services/partner.service';

@Component({
  selector: 'app-tab-dados-parceiro',
  templateUrl: './tab-dados-parceiro.component.html',
  styleUrls: ['./tab-dados-parceiro.component.scss']
})
export class TabDadosParceiroComponent {
  ERoleAdminString = ERoleAdminString;
  @Input() formPartner!: UntypedFormGroup;

  opcoesTipoPartner: string[] = [];

  constructor(private readonly partnerService: PartnerService) {
    this.opcoesTipoPartner = this.partnerService.opcoesTipoParceiro;
  }
}
